import React, {
  useState, useEffect, Dispatch, SetStateAction,
} from 'react';
import { connect } from 'react-redux';

import { Box, Inline } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import withStore from '../../../../withStore';

import {
  BodyText, Button,
} from '../../../../ui';

import { NotificationsQuestionCircleIcon } from '../../../../ui/Icons';

import analytics from '../../../../../modules/analytics';

import {
  PRO_SEARCH_BOOST_MODES,
} from '../../../constants';

import InfoModal from './InfoModal';

type CTA = {
  text: string;
  onClick: () => void;
};

type InfoButtonContainerProps = {
  currentValue?: number;
  ctaData: {
    text: string;
    tracking: string;
    route: string;
  };
  mode: string;
  linkTo: (route: string, params: any) => void;
  providerId: number;
};

export const InfoButtonContainer: React.FC<InfoButtonContainerProps> = ({
  mode,
  ctaData,
  currentValue = 0,
  linkTo,
  providerId,
}) => {
  const [open, setOpen]: [boolean, Dispatch<SetStateAction<boolean>>] = useState();
  const [cta, setCta]: [CTA, Dispatch<SetStateAction<CTA>>] = useState();

  const trackEvent = event => {
    analytics.track(event, { mode, provider_id: providerId });
  };

  const closeModal = tracking => {
    trackEvent(`pro_whatisboost_${tracking}`);

    setOpen(false);
  };

  const openModal = () => {
    trackEvent('pro_home_searchboost_whatisboost_click');

    setOpen(true);
  };

  const onOpen = () => trackEvent('pro_whatisboost_view');

  useEffect(() => {
    if (ctaData) {
      setCta({
        text: ctaData.text,
        onClick: () => {
          trackEvent(`pro_whatisboost_${ctaData.tracking}`);

          linkTo(ctaData.route, { providerId });
        },
      });
    }
  }, [ctaData]);

  const passThroughProps = {
    cta,
    currentValue,
    onOpen,
    closeModal,
  };

  return (
    <Box minWidth="100%" paddingTop={24}>
      <Button
        onClick={openModal}
        size="small"
        testID="whatisboost-button"
        style={{
          backgroundColor: colors.blue,
          borderRadius: '0px',
        }}
      >
        <Inline justifyContent="center" alignItems="center" space={4} padding={4}>
          <NotificationsQuestionCircleIcon color={colors.whiteWash} width={15} height={15} />
          <BodyText appearance="normal" weight="bold" color={colors.whiteWash}>
            What is Search Boost?
          </BodyText>
        </Inline>
      </Button>
      {open && (
        <InfoModal
          {...passThroughProps}
          progressDisabled={mode === PRO_SEARCH_BOOST_MODES.preEarning}
        />
      )}
    </Box>
  );
};

const mapDispatchToProps = dispatch => ({
  linkTo: (route, params, notify = true) => {
    dispatch.route.go({
      route,
      params,
      notify,
    });
  },
});

export default withStore(connect(null, mapDispatchToProps)(InfoButtonContainer));
